import styled from 'styled-components';

const ErrorWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 8px;
`;

export default ErrorWrapper;
